import { useModal } from "@ebay/nice-modal-react";
import { css } from "@emotion/css";
import { UseFormHook, WithFormProps } from "src/components/forms/Form";
import AgreementModel from "src/models/AgreementModel";
import { modals } from "src/utils/modals";
import { BorderButton } from "../buttons/BorderButton";
import InputCheckbox from "../inputs/InputCheckbox";
import Modal from "../modals/Modal";

interface Props extends WithFormProps {
  agreement: AgreementModel;
  onChange?: (e) => void;
  checked?: boolean;
}

export function Agreement(props: Props) {
  function viewAgreement() {
    modals.show(AgreementModal, {
      agreement: props.agreement,
      form: props.form,
    });
  }

  function onChange(checked) {
    if (props.agreement.required && checked) {
      viewAgreement();
    } else {
      props.onChange({ target: { checked } });
    }
  }

  return (
    <>
      <div className="flex cursor-pointer">
        <InputCheckbox
          onChange={onChange}
          checked={props.checked}
          className="flex-0"
        />
        <div className="relative -top-px pl-4" onClick={viewAgreement}>
          {props.agreement.title}
          <br />
          <span className="text-organization">View Agreement</span>
        </div>
      </div>
    </>
  );
}

export const AgreementModal = modals.create(
  (props: { agreement: AgreementModel; form?: UseFormHook<any> }) => {
    const modal = useModal();

    function agree() {
      if (props.form) {
        props.form.setFieldsValue({
          [`agreement-${props.agreement.id}`]: true,
        });
      }

      modal.hide();
    }

    const description = props.agreement.description.replace(
      /(?:\r\n|\r|\n)/g,
      "<br />"
    );

    return (
      <Modal
        visible={modal.visible}
        handleCancel={modal.hide}
        afterClose={modal.remove}
        title={props.agreement.title}
        footer={
          <>
            <BorderButton type="submit" onClick={agree}>
              {props.form ? "I agree" : "Close"}
            </BorderButton>
          </>
        }
      >
        <div
          className={css({
            "& p": {
              marginRight: "0 !important",
            },
          })}
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <div className="mb-4" />
      </Modal>
    );
  }
);
